import axios from 'axios'
import Cookies from 'js-cookie'
import { URL } from '@/config/env'
// import router from '../router/index'

let baseAxios = axios.create({
  baseURL: URL.baseURL,
  headers: {
    'Access-Control-Allow-Origin': '*'
  },
  timeout: 60000
});

baseAxios.interceptors.request.use(function (config) {
  if (config.auth) {
    return config;
  }

  const tokenValue = Cookies.get('Token');

  if (tokenValue) {
    config.headers.Authorization = `Bearer ${tokenValue}`;
  }
  console.log('config', config);
  if (config.config !== undefined && config.config.requestBase === 'dotnet8') {
    config.baseURL = URL.baseNewURL
  } else {
    config.baseURL = URL.baseURL
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

baseAxios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  console.log('这里response.data报错');
  console.log(error);
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // router.replace({
        //   path: '/',
        //   query: {
        //     redirect: router.currentRoute.fullPath
        //   }
        // })
        window.location.href = '/index';
    }
    return Promise.reject(error.response.data);
  } else {
    this.$alert('网络连结超时，请检查网络', '提示', {
      confirmButtonText: '确定'
    });
    return Promise.reject(error.response);
  }
});

// get请求 路由示例：http:www.xx.com/user?id=1
baseAxios.getAsync = function (commit, URL, params, config) {
  console.log('config', config)
  return new Promise(function (resolve, reject) {
    baseAxios.get(URL.split('_')[0], {
      params: params,
      config: config
    }).then((response) => {
      let retData = response.data;
      let orginalData = retData.Data;
      commit(URL, orginalData);
      resolve(retData);
    }, (error) => {
      console.log(error);
      reject(error);
    })
  })
};

// get请求 路由示例：http:www.xx.com/user/1
baseAxios.getAsyncWithConcat = function (commit, URL, params, config) {
  return new Promise(function (resolve, reject) {
    baseAxios.get(window.Utils.concatGetRequestParam(URL.split('_')[0], params, config)).then((response) => {
      let retData = response.data;
      let orginalData = retData.Data;
      commit(URL, orginalData);
      resolve(retData);
    }, (error) => {
      console.log(error);
      reject(error);
    })
  })
}

// del请求 路由示例：路由示例：http:www.xx.com/user
baseAxios.deleteAsync = function (commit, URL, params) {
  return new Promise(function (resolve, reject) {
    baseAxios.delete(URL.split('_')[0], {
      params: params
    }).then((response) => {
      let retData = response.data;
      let orginalData = retData.Data;
      commit(URL, orginalData);
      resolve(retData);
    }, (error) => {
      console.log(error);
      reject(error);
    })
  })
};

// det请求 路由示例：http:www.xx.com/user/1
baseAxios.deleteAsyncWithConcat = function (commit, URL, params) {
  return new Promise(function (resolve, reject) {
    baseAxios.delete(window.Utils.concatGetRequestParam(URL.split('_')[0], params)).then((response) => {
      let retData = response.data;
      let orginalData = retData.Data;
      commit(URL, orginalData);
      resolve(retData);
    }, (error) => {
      console.log(error);
      reject(error);
    })
  })
};

// post请求 路由示例：http:www.xx.com/user
baseAxios.postMutationsAsync = function (commit, URL, params, headers = {}) {
  return new Promise(function (resolve, reject) {
    baseAxios.post(URL.split('_')[0], params, headers
    ).then((response) => {
      let retData = response.data;
      let orginalData = retData.Data;
      commit(URL, orginalData);
      resolve(retData);
    }, (error) => {
      console.log(error);
      reject(error);
    })
  })
};

// post请求 路由示例：http:www.xx.com/user
baseAxios.postAsync = function (commit, URL, params, headers = {}) {
  return new Promise(function (resolve, reject) {
    baseAxios.post(URL.split('_')[0], params, headers
    ).then((response) => {
      let retData = response.data;
      // let orginalData = retData.Data;
      // commit(URL, orginalData);
      resolve(retData);
    }, (error) => {
      console.log(error);
      reject(error);
    })
  })
};

// post请求 参数是Form对象 路由示例：http:www.xx.com/user
baseAxios.postFormDataAsync = function (commit, URL, params, headers = {}) {
  params = objectToFormData(params);
  return new Promise(function (resolve, reject) {
    baseAxios.post(URL.split('_')[0], params, headers
    ).then((response) => {
      let retData = response.data;
      resolve(retData);
    }, (error) => {
      console.log(error);
      reject(error);
    })
  })
};

// put请求 路由示例：http:www.xx.com/user
baseAxios.putAsync = function (commit, URL, params, headers = {}) {
  return new Promise(function (resolve, reject) {
    baseAxios.put(URL.split('_')[0], params, headers
    ).then((response) => {
      let retData = response.data;
      resolve(retData);
    }, (error) => {
      console.log(error);
      reject(error);
    })
  })
};

// put请求 路由示例：http:www.xx.com/user
baseAxios.putFormDataAsync = function (commit, URL, params, headers = {}) {
  params = objectToFormData(params);
  return new Promise(function (resolve, reject) {
    baseAxios.put(URL.split('_')[0], params, headers
    ).then((response) => {
      let retData = response.data;
      resolve(retData);
    }, (error) => {
      console.log(error);
      reject(error);
    })
  })
};

/**
 *
 *
 * @param {*} object
 * @returns
 */
// function objectToFormData(object) {
//   const formData = new FormData();
//   if (Object.prototype.toString.call(object) === '[object Array]') {
//     Object.keys(object).forEach((key) => {
//       Object.keys(object[key]).forEach((key1) => {
//         formData.append(key1, object[key][key1]);
//       })
//     });
//   } else {
//     Object.keys(object).forEach((key) => {
//       if (Object.prototype.toString.call(object[key]) === '[object Array]') {
//         if (key === 'FileList') {
//           Object.keys(object[key]).forEach((key1) => {
//             Object.keys(object[key][key1]).forEach(key2 => {
//               formData.append('FileList[' + key1 + '].' + key2, object[key][key1][key2]);
//             })
//           })
//         } else {
//           Object.keys(object[key]).forEach((key1) => {
//             formData.append(key, object[key][key1]);
//           })
//         }
//       } else {
//         formData.append(key, object[key]);
//       }
//     });
//   }

//   return formData;
// }

// function objectToFormData(obj, form, namespace) {
//   debugger;
//   let fd = form || new FormData();
//   let formKey;
//   if (obj instanceof Array) {
//     for (let item of obj) {
//       if (typeof item === 'object' && !(item instanceof File)) {
//         this.objectToFormData(item, fd, namespace + '[]');
//       } else {
//         // 若是数组则在关键字后面加上[]
//         fd.append(namespace + '[]', item)
//       }
//     }
//   } else {
//     for (let property in obj) {
//       if (obj.hasOwnProperty(property) && obj[property]) {
//         if (namespace) {
//           // 若是对象，则这样
//           formKey = namespace + '[' + property + ']';
//         } else {
//           formKey = property;
//         }

//         // if the property is an object, but not a File,
//         // use recursivity.
//         if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
//           // 此处将formKey递归下去很重要，因为数据结构会出现嵌套的情况
//           this.objectToFormData(obj[property], fd, formKey);
//         } else {
//           // if it's a string or a File object
//           fd.append(formKey, obj[property]);
//         }
//       }
//     }
//   }
//   return fd;
// }

// obj 转 FormData 可以无限嵌套
function objectToFormData(obj, rootName, ignoreList) {
  let formData = new FormData();

  function appendFormData(data, root) {
    if (!ignore(root)) {
      root = root || '';
      if (data instanceof File) {
        formData.append(root, data);
      } else if (Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          appendFormData(data[i], root + '[' + i + ']');
        }
      } else if (typeof data === 'object' && data) {
        for (let key in data) {
          if (data.hasOwnProperty(key)) {
            if (root === '') {
              appendFormData(data[key], key);
            } else {
              appendFormData(data[key], root + '.' + key);
            }
          }
        }
      } else {
        if (data !== null && typeof data !== 'undefined') {
          formData.append(root, data);
        }
      }
    }
  }

  function ignore(root) {
    return Array.isArray(ignoreList) && ignoreList.some(function (x) { return x === root; });
  }

  appendFormData(obj, rootName);

  return formData;
}

export default baseAxios;



// WEBPACK FOOTER //
// ./src/common/axios.js